import React from 'react';
import iconMap from '../data/iconMap';
import { IconContext } from "react-icons";
import { BoxContainerStyled, BoxTitleStyled, BoxIconContainerStyled } from '../styles/Box';


function Box({title, name, mode, onClick, index}) {

    return (
        <IconContext.Provider value={{ style: { fontSize: '20px' } }}>
            <BoxContainerStyled $delay={index * 0.3} $active={mode===name} onClick={() => onClick(name)}>
                <BoxIconContainerStyled>{iconMap[name]}</BoxIconContainerStyled>
                <BoxTitleStyled>{title}</BoxTitleStyled>
            </BoxContainerStyled>
        </IconContext.Provider>
    );
}

export default Box;